module.exports = __webpack_public_path__ + "static/DSC_7895-eb3d62c33fe0302369d4c0cec3b71d8c.jpg";